const EASTERN_START = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZoneName: "short",
});

export function formatGameStartTimeUtcToEST(utcTime: string): string {
  const part = Object.fromEntries(EASTERN_START.formatToParts(new Date(utcTime)).map(({ type, value }) => [type, value]));
  return `${part.month} ${part.day} @ ${part.hour}:${part.minute} ${part.dayPeriod} ${part.timeZoneName}`;
}
